export const OnClickAction = (arrayData: any) => {
  return {
    type: 'onclick',
    arrayData,
  }
}